import APP_VERSION from '../version';

/* Poredi verziju zapečenu u bundle (APP_VERSION) sa verzijom na serveru (meta.json, fetch bez keša).
   meta.json sa servera je jedini pouzdan izvor — keširan stari bundle nosi staru konstantu.
   Vraća true ako je pokrenut reload na novu verziju (pozivalac tad NE treba da nastavlja dalje),
   false ako je verzija ista / provera nije uspela (nastavi normalno).

   Opcija sacuvajSesiju: prenosi prijavu preko reload-a. Koristi je login — tako
   prijava na novu verziju prolazi iz prvog klika. */
export default async function checkVersion({ sacuvajSesiju = false } = {}) {
    /* Samo u produkciji: deploy regeneriše meta.json iz build-a (prebuild), pa je pouzdan izvor.
       U dev-u (npm start) meta.json se NE regeneriše → zastareo je (npr. 1.0.9) i pravi lažan
       mismatch sa APP_VERSION iz bundla → beskorisan reload i ?v=... u URL-u. */
    if (process.env.NODE_ENV !== 'production') return false;
    try {
        const res = await fetch(`${process.env.PUBLIC_URL || ''}/meta.json?ts=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return false;
        const meta = await res.json();
        if (!meta?.version || meta.version === APP_VERSION) return false;

        /* zaštita od reload petlje: ako server iz nekog razloga i dalje služi stari bundle
           (CDN/proxy keš), ne reload-uj ponovo u istoj sesiji */
        if (sessionStorage.getItem('versionReloadDone') === meta.version) return false;

        /* Kad se proverava POSLE prijave (sacuvajSesiju), sesija se prenosi preko
           ciscenja — inace bi korisnik posle reload-a opet gledao login formu i
           morao da klikne drugi put. Prenosi se samo ono bez cega se sesija ne
           obnavlja: redux state (u njemu je token) i oznaka da je kartica aktivna.
           Sve ostalo namerno propada — to je i smisao ciscenja. */
        const sesija = sacuvajSesiju
            ? {
                state: localStorage.getItem('state'),
                sessionActive: sessionStorage.getItem('sessionActive'),
            }
            : null;

        if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map(k => caches.delete(k)));
        }
        localStorage.clear();
        sessionStorage.clear();
        if (sesija?.state) localStorage.setItem('state', sesija.state);
        if (sesija?.sessionActive) sessionStorage.setItem('sessionActive', sesija.sessionActive);
        sessionStorage.setItem('versionReloadDone', meta.version);
        /* query param menja URL dokumenta → browser ne sme da posluži keširan index.html */
        window.location.replace(`${window.location.pathname}?v=${encodeURIComponent(meta.version)}`);
        return true;
    } catch {
        /* meta.json nedostupan (dev server, mreža) — ne blokiraj aplikaciju */
        return false;
    }
}
